import React, { useState } from "react";
import "./style.scss";
import { useStores } from "../../stores";
import SuccessModal from "../../components/SuccessModal";

function LeadForm({ onFilterCityData }) {
  const [successModal, setSuccessModal] = useState(false);
  const [leadFormStatus, setLeadFormStatus] = useState("");
  const [leadFormMessage, setLeadFormMessage] = useState("");
  const { bookingStore } = useStores();
  const [debounceTimeout, setDebounceTimeout] = useState(null);


  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    city_id: "",
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    mobile: "",
    email: "",
    city_id: "",
  });

  const getFormLead = async (formData) => {
    await bookingStore.getLeadFormDayPass(formData, (response) => {
      if (response?.data?.status === 1) {
        console.log("success");
        setSuccessModal(true);
        setLeadFormStatus("Success");
        setLeadFormMessage("Thankyou. We've received your enquiry");
        setFormData({
            name: "",
            mobile: "",
            email: "",
            city_id: "",
          });
      } else {
        setSuccessModal(true);
        setLeadFormStatus("Failed");
        setLeadFormMessage(response?.response?.data?.data[0]);
      }
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Reset the error message when the user starts typing in the field
    setFormErrors({
      ...formErrors,
      [name]: "",
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...formErrors };

    // Validate name
    if (!formData.name) {
      newErrors.name = "Please enter a name";
      isValid = false;
    }

    // Validate mobile number
    if (!formData.mobile || !/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number";
      isValid = false;
    }

    // Validate email
    if (!formData.email || !/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
      isValid = false;
    }

    // Validate selectedCity
    if (!formData.city_id) {
      newErrors.city_id = "Please select a city";
      isValid = false;
    }

    setFormErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      formData.inv_type_id = 15;
      formData.inv_type = 15;
      formData.city_id = parseInt(formData.city_id, 10);
      formData.url = window.location.href;
      console.log("Form Data:", formData);

      // Clear the previous debounce timeout
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }

      // Set a new debounce timeout
      const newTimeout = setTimeout(() => {
        getFormLead(formData);
      }, 500);

      setDebounceTimeout(newTimeout);
    }
  };
  

  return (
    <>
      <div className="contact-box-daypass">
        <h3 className="contact-heading">
          Still don’t see what you’re looking for?
        </h3>
        <p className="contact-sub-heading-day-pass">
          Get a member of our team to do the searching - we’ll help you find the
          right workspace.
        </p>
        <form className="contact-form-day-pass" onSubmit={handleSubmit}>
          <div className="row-form row-center">
            <div className="form-col-daypass mob-pd">
              <input
                type="text"
                className={`form-control contact-field ${
                  formErrors.name && "error"
                }`}
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
              {formErrors.name && (
                <label className="errorTextMsg">{formErrors.name}</label>
              )}
            </div>
            <div className="form-col-daypass mob-pd">
              <input
                type="tel"
                className={`form-control contact-field ${
                  formErrors.mobile && "error"
                }`}
                placeholder="Mobile Number"
                name="mobile"
                maxLength="10"
                pattern="[0-9]*"
                value={formData.mobile}
                onChange={handleInputChange}
              />
              {formErrors.mobile && (
                <label className="errorTextMsg">{formErrors.mobile}</label>
              )}
            </div>
            <div className="form-col-daypass mob-pd">
              <input
                type="email"
                className={`form-control contact-field ${
                  formErrors.email && "error"
                }`}
                placeholder="Email Id"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {formErrors.email && (
                <label className="errorTextMsg">{formErrors.email}</label>
              )}
            </div>
            <div className="form-col-daypass mob-pd">
              <select
                className={`form-control contact-field ${
                  formErrors.city_id && "error"
                }`}
                id="sel1"
                name="city_id"
                value={formData.city_id}
                onChange={handleInputChange}
              >
                <option value="">Select a city</option>
                {onFilterCityData &&
                  onFilterCityData.map((city) => (
                    <option
                      key={city.id}
                      className="cityoptionfield"
                      value={city.id}
                    >
                      {city.name}
                    </option>
                  ))}
              </select>
              {formErrors.city_id && (
                <label className="errorTextMsg">{formErrors.city_id}</label>
              )}
            </div>
            <div className="col-md-12">
              <button type="submit" className="btn-contact">
                Submit
              </button>
            </div>
          </div>
        </form>
        <p className="contact-sub-heading-day-pass call-us-day-pass">Or call us on 1860 258 6633</p>
      </div>
      <SuccessModal
        show={successModal}
        hide={() => {
          setSuccessModal(false);
        }}
        status={leadFormStatus}
        message={leadFormMessage}
      />
    </>
  );
}

export default LeadForm;
